import { REGISTRATION_ROUTES } from 'gcs-common/constants/routes';
import { getIsRegistered } from 'gcs-common/slices/currentUser/currentUserSelectors';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';

const OnlinePlusWebWrapper = ({ children }: { children: ReactNode }) => {
  const isRegistered = useSelector(getIsRegistered);

  if (isRegistered) {
    return <Navigate to={REGISTRATION_ROUTES.REGISTRATION_NOTIFICATIONS} replace />;
  }
  return (
    <div className="flex h-full items-center justify-center px-6">
      <div className="w-[360px] text-center">{children}</div>
    </div>
  );
};

export default OnlinePlusWebWrapper;
